module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fc-Gd-Hc-Ia.a839db5a.png";